import Organizations from "entities/Organizations";
import { get } from "lodash";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { StoreContext } from "shared/store";
import { SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const { user } = useContext(StoreContext);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.COMPANY);
  const LIST = t("LIST", { returnObjects: true });
  const take = 10;
  const [filter, setFilter] = useState({
    take,
    skip: 0,
    where: {
      contracts: {
        organization: {
          id: get(user, "organization.id"),
        },
      },
    },
  });

  const navigate = useNavigate();

  const onSearch = (value) => {
    setFilter((prev) => ({
      ...prev,
      skip: 0,
      like: {
        OR: [{ name: `%${value}%` }],
      },
    }));
  };

  const buttons = [
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () => setShowCreateForm(true),
    },
  ];

  const onDetail = (id) =>
    navigate(`${SCREENS.PRIVATE.ADMIN.COMPANIES.DETAIL.path}/${id}`);

  const onDelete = (id) =>
    navigate(`${SCREENS.PRIVATE.ADMIN.COMPANIES.DELETE.path}/${id}`);

  return (
    <>
      <Header
        title={LIST.HEADER.TITLE}
        // subtitle={LIST.HEADER.SUBTITLE}
        actions={buttons}
      />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.SEARCH}
            type="search"
            onChange={({ target: { value } }) => onSearch(value)}
          />
        </div>
        <Organizations
          View={View}
          filter={filter}
          NoData={View}
          onDetail={onDetail}
          onDelete={onDelete}
          showCreateForm={showCreateForm}
          setShowCreateForm={setShowCreateForm}
          take={take}
        />
      </Card>
      {/* <Upload open={open} setOpen={setOpen} onCancel={() => setOpen(false)} /> */}
    </>
  );
};

export default List;
